import React from 'react';

interface ProductSubCategory {
  id: number;
  name: string;
  status: boolean;
}

interface ProductSubCategoryTableProps {
  subCategories: ProductSubCategory[];

  onEdit: (
    subCategory: ProductSubCategory
  ) => void;

  onToggleStatus: (
    id: number
  ) => void;
}

const ProductSubCategoryTable: React.FC<
  ProductSubCategoryTableProps
> = ({
  subCategories,
  onEdit,
  onToggleStatus,
}) => {
  return (
    <div className="overflow-x-auto">

      <table className="w-full">

        <thead>
          <tr className="border-b border-stroke dark:border-strokedark">

            <th className="px-4 py-4 text-left text-sm font-semibold text-black dark:text-white">
              Nombre
            </th>

            <th className="px-4 py-4 text-center text-sm font-semibold text-black dark:text-white">
              Estado
            </th>

            <th className="px-4 py-4 text-center text-sm font-semibold text-black dark:text-white">
              Acciones
            </th>

          </tr>
        </thead>

        <tbody>

          {subCategories.length === 0 ? (
            <tr>
              <td
                colSpan={3}
                className="py-12 text-center text-gray-500"
              >
                Seleccione una categoría para visualizar sus subcategorías.
              </td>
            </tr>
          ) : (
            subCategories.map((subCategory) => (
              <tr
                key={subCategory.id}
                className="
                  border-b
                  border-stroke
                  dark:border-strokedark
                  hover:bg-gray-1
                  dark:hover:bg-meta-4
                  transition
                "
              >

                <td className="px-4 py-3 text-sm font-medium text-black dark:text-white">
                  {subCategory.name}
                </td>

                <td className="px-4 py-3 text-center">

                  <span
                    className={`inline-flex rounded-full px-3 py-1 text-xs font-medium text-white ${
                      subCategory.status
                        ? 'bg-[#3CA745]'
                        : 'bg-[#DC3545]'
                    }`}
                  >
                    {subCategory.status
                      ? 'Activo'
                      : 'Inactivo'}
                  </span>

                </td>

                <td className="px-4 py-3">

                  <div className="flex justify-center gap-2">

                    <button
                      onClick={() =>
                        onEdit(subCategory)
                      }
                      className="
                        rounded-md
                        bg-primary
                        px-3
                        py-1.5
                        text-xs
                        font-medium
                        text-white
                        hover:bg-opacity-90
                      "
                    >
                      Editar
                    </button>

                    <button
                      onClick={() =>
                        onToggleStatus(
                          subCategory.id
                        )
                      }
                      className={`rounded-md px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90 ${
                        subCategory.status
                          ? 'bg-[#DC3545]'
                          : 'bg-[#3CA745]'
                      }`}
                    >
                      {subCategory.status
                        ? 'Desactivar'
                        : 'Activar'}
                    </button>

                  </div>

                </td>

              </tr>
            ))
          )}

        </tbody>

      </table>

    </div>
  );
};

export default ProductSubCategoryTable;